import { render } from "./InstallmentsView.vue?vue&type=template&id=5c3e2730&ts=true"
import script from "./InstallmentsView.vue?vue&type=script&lang=ts"
export * from "./InstallmentsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__